<template><component :is="component" v-bind="$props"></component></template>

<script lang="ts">
import {
  composeEvent,
  injectEvent
} from "@fresh8/ad-data-composition/src/betData";
import { SportEnum } from "@fresh8/types/src/language";
import { computed, defineComponent } from "vue";

import AmericanFootball from "./sports/AmericanFootball.vue";
import NoSleeveJersey from "./sports/NoSleeveJersey.vue";
import ShortSleeveJersey from "./sports/ShortSleeveJersey.vue";

import Baseball from "./sports/Baseball.vue";
import LongSleeveJersey from "./sports/LongSleeveJersey.vue";

export default defineComponent({
  name: "TeamJerseySelector",
  props: {
    eventId: {
      type: String,
      required: false,
      default: undefined
    }
  },
  setup(props) {
    const sport = computed(() =>
      props.eventId
        ? composeEvent(props.eventId)!.value?.sport!
        : injectEvent().value.sport
    );

    const component = computed(() => {
      switch (sport.value) {
        case SportEnum.AMERICAN_FOOTBALL:
          return AmericanFootball;
        case SportEnum.FOOTBALL:
          return ShortSleeveJersey;
        case SportEnum.BASEBALL:
          return Baseball;
        case SportEnum.BASKETBALL:
          return NoSleeveJersey;
        case SportEnum.ICE_HOCKEY:
          return LongSleeveJersey;
        default:
          return undefined;
      }
    });

    return { component };
  }
});
</script>
